<template>
  <div class="detail-wrapper">
    <!-- 微信提示 -->
<!--    <div v-if="isWeChat" class="wechat-tip-card">-->
<!--      <div class="wechat-tip">-->
<!--        <p>请在浏览器中打开以获得更好的体验</p>-->
<!--        <van-button type="primary" block round @click="openInBrowser" class="browser-btn">-->
<!--          点击复制链接并在浏览器中打开-->
<!--        </van-button>-->
<!--        &lt;!&ndash; <van-button plain block round @click="isWeChat = true" class="return-btn">-->
<!--          返回-->
<!--        </van-button> &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->

    <!-- 详情内容 -->
    <div class="detail-content">
      <!-- 基本信息 -->
      <div class="detail-card" v-if="detail">
        <div class="card-header">
          <div class="header-title">基本信息</div>
        </div>

        <div class="info-list">
          <div class="info-item">
            <div class="info-label">司机姓名</div>
            <div class="info-value">{{detail.driverName}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">司机联系方式</div>
            <div class="info-value">{{detail.driverPhone}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">车头号</div>
            <div class="info-value">{{detail.headstock}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">车挂号</div>
            <div class="info-value">{{detail.handnum}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">上一载品种</div>
            <div class="info-value">{{detail.variety}}</div>
          </div>

          <div class="info-item" v-if="detail.cargoHoldsNumbs">
            <div class="info-label">隔舱数量</div>
            <div class="info-value">{{detail.cargoHoldsNumbs}}</div>
          </div>

          <!-- <div class="info-item">
            <div class="info-label">蒸洗口</div>
            <div class="info-value">{{detail.steamPort}}</div>
          </div> -->

          <div class="info-item">
            <div class="info-label">罐体材质</div>
            <div class="info-value">{{detail.tankMaterial}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">有溢油探头</div>
            <div class="info-value">{{ detail.isOilSpillProbe == 'Y' ? '是' : '否' }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">预约日期</div>
            <div class="info-value">{{detail.appointmentTime}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">预约时间</div>
            <div class="info-value">{{detail.appointmentPdxx}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">预约项目</div>
            <div class="info-value">{{detail.steamChargeitemTitle}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">预约项目金额</div>
            <div class="info-value highlight">{{detail.steamChargeitemFee/100 + '元'}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">预支付金额</div>
            <div class="info-value highlight">{{detail.payedFee/100 +'元'}}</div>
          </div>

          <div class="info-item" v-if="detail.bpmStatus == '1'">
            <div class="info-label">作业状态</div>
            <div class="info-value"><van-tag type="warning">待作业</van-tag></div>
          </div>

          <div class="info-item" v-if="detail.bpmStatus == '2'">
            <div class="info-label">预约状态</div>
            <div class="info-value"><van-tag type="success">处理完成</van-tag></div>
          </div>
        </div>
      </div>

      <!-- 检测信息 -->
      <div class="detail-card" v-if="detail">
        <div class="card-header">
          <div class="header-title">检测信息</div>
        </div>

        <div class="info-list">
          <div class="info-item">
            <div class="info-label">清洗残留物质</div>
            <div class="info-value">
              <span class="detection-value">{{detail.cleanResidualSubstances}}</span>
              <span class="detection-desc">卸料管洁净无残留物。</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-label">蒸罐检测</div>
            <div class="info-value">
              <span class="detection-value">{{detail.gasDetection}}</span>
              <span class="detection-desc">无可燃气体、有毒气体。</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-label">清洗检测</div>
            <div class="info-value">
              <span class="detection-value">{{detail.cleanDetection}}</span>
              <span class="detection-desc">罐内无死角，无泥沙、木屑、油迹、纤维绒毛、明显铁锈、黑色污物等。</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-label">干燥检测</div>
            <div class="info-value">
              <span class="detection-value">{{detail.dryTesting}}</span>
              <span class="detection-desc">罐内无死角，无水（冰）、泥沙、木屑、油迹、纤维绒毛、明显铁锈、黑色污物等，罐体外卸油口洁净，凹槽处无积水、污物。</span>
            </div>
          </div>

          <div class="info-item">
            <div class="info-label">通风检测</div>
            <div class="info-value">
              <span class="detection-value">{{detail.odorDetection}}</span>
              <span class="detection-desc">温度降为常温或以下，无可燃气体、有毒气体。</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 操作信息 -->
      <div class="detail-card" v-if="detail">
        <div class="card-header">
          <div class="header-title">操作信息</div>
        </div>

        <div class="info-list">
          <div class="info-item">
            <div class="info-label">操作人</div>
            <div class="info-value">{{detail.xcOperationName}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">操作开始时间</div>
            <div class="info-value">{{detail.assignmentStartTime}}</div>
          </div>

          <div class="info-item">
            <div class="info-label">操作结束时间</div>
            <div class="info-value">{{detail.assignmentEndTime}}</div>
          </div>

          <div class="info-item" v-if="detail.xcOperationRemark">
            <div class="info-label">其他情况</div>
            <div class="info-value">{{detail.xcOperationRemark}}</div>
          </div>
        </div>
      </div>

      <!-- 上一载重磅单 -->
      <div class="detail-card" id="bdpic" v-if="detail && detail.poundListUrl">
        <div class="card-header">
          <div class="header-title">上一载重磅单</div>
        </div>

        <div class="image-container">
          <van-image :src="detail.poundListUrl" fit="contain" class="detail-image" />
        </div>
      </div>

      <!-- 洗舱前照片 -->
      <div class="detail-card" v-if="beforeCleanImageArr.length>0">
        <div class="card-header">
          <div class="header-title">洗舱前照片</div>
        </div>

        <div class="image-container" v-for="item in beforeCleanImageArr" :key="item.id">
          <van-image :src="item.url" fit="contain" class="detail-image" />
        </div>
      </div>

      <!-- 洗舱中照片 -->
      <div class="detail-card" v-if="cleaningImageArr.length>0">
        <div class="card-header">
          <div class="header-title">洗舱中照片</div>
        </div>

        <div class="image-container" v-for="item in cleaningImageArr" :key="item.id">
          <van-image :src="item.url" fit="contain" class="detail-image" />
        </div>
      </div>

      <!-- 洗舱后照片 -->
      <div class="detail-card" v-if="afterCleanImageArr.length>0">
        <div class="card-header">
          <div class="header-title">洗舱后照片</div>
        </div>

        <div class="image-container" v-for="item in afterCleanImageArr" :key="item.id">
          <van-image :src="item.url" fit="contain" class="detail-image" />
        </div>
      </div>

      <!-- 司机签字照片 -->
      <div class="detail-card" v-if="detail && detail.driverSignUrl">
        <div class="card-header">
          <div class="header-title">司机签字照片</div>
        </div>

        <div class="image-container">
          <van-image :src="detail.driverSignUrl" fit="contain" class="detail-image" />
        </div>
      </div>

      <!-- 预约二维码 -->
      <div class="detail-card qrcode-card">
        <div class="card-header">
          <div class="header-title">预约二维码</div>
        </div>

        <div id="qrcode" class="qrcode-container"></div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer-actions" v-if="showPrintBtn">
      <van-button
        type="info"
        block
        round
        class="print-btn"
        @click="openInBrowser"
      >
        <van-icon name="down" /> 下载蒸洗证明
      </van-button>
    </div>

    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from "@/views/Public/tabbarTpl.vue";
import steamApi from "@/fetch/steamApi.js";
import QRCode from 'qrcodejs2-fix'
export default {
  components: {
    Tabbar,
  },
  inject: ['reload'],
  data()
  {
    return {
      detail:null,
      beforeCleanImageArr:[],
      afterCleanImageArr:[],
      cleaningImageArr:[],
      showPrintBtn:false,
      isWeChat:false,
    }
  },
  created()
  {
    document.title = "蒸洗作业详情";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getSteamAssignmentDetail(id);
  },
  methods:{
    qrcode(yybh) {
      if(yybh)
      {

        document.getElementById('qrcode').textContent = '';
        new QRCode('qrcode', {
          text: yybh // 二维码内容
        })
      }
    },
    getSteamAssignmentDetail(id)
    {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      var postData = {
          id:id
      }
      steamApi.getSteamAssignmentDetail(postData).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == "0") {
          var detail = res.data;

          if(detail)
          {
              detail.cleanResidualSubstances = detail.cleanResidualSubstances == "Y" ? "合格" : detail.cleanResidualSubstances == "N" ? "不合格" : "不涉及"
              detail.gasDetection = detail.gasDetection == "Y" ? "合格" : detail.gasDetection == "N" ? "不合格" : "不涉及"
              detail.cleanDetection = detail.cleanDetection == "Y" ? "合格" : detail.cleanDetection == "N" ? "不合格" : "不涉及"
              detail.dryTesting = detail.dryTesting == "Y" ? "合格" : detail.dryTesting == "N" ? "不合格" : "不涉及"
              detail.odorDetection = detail.odorDetection == "Y" ? "合格" : detail.odorDetection == "N" ? "不合格" : "不涉及"

              switch (detail.compartmentCount) {
                  case "01":
                  detail.cangshiTitle = "单舱";
                  break;
                  case "02":
                  detail.cangshiTitle = "双舱";
                  break;
                  case "03":
                  detail.cangshiTitle = "三舱";
                  break;
                  default:
                  detail.cangshiTitle = "";
              }

              if(detail.poundListUrl) detail.poundListUrl = weburl + '/' + detail.poundListUrl;
              if(detail.driverSignUrl) detail.driverSignUrl = weburl + '/' + detail.driverSignUrl;
              var beforeCleanUrlNew = detail.beforeCleanPic;
              var beforeCleanImageArrNew = [];
              if (beforeCleanUrlNew && beforeCleanUrlNew != null) {
                  var imageDataArr = beforeCleanUrlNew.split(',');

                  for (var k = 0; k < imageDataArr.length; k++) {
                  beforeCleanImageArrNew.push({
                      'url': weburl + '/' + imageDataArr[k]
                  });
                  }

                  that.beforeCleanImageArr =  beforeCleanImageArrNew;
              }

              var cleaningUrlNew = detail.cleaningPic;
              var cleaningImageArrNew = [];
              if (cleaningUrlNew && cleaningUrlNew != null) {
                  var imageDataArr3 = cleaningUrlNew.split(',');

                  for (var k3 = 0; k3 < imageDataArr3.length; k3++) {
                  cleaningImageArrNew.push({
                      'url': weburl + '/' + imageDataArr3[k3]
                  });
                  }

                  that.cleaningImageArr =  cleaningImageArrNew;
              }

              var afterCleanUrlNew = detail.afterCleanPic;
              var afterCleanImageArrNew = [];
              if (beforeCleanUrlNew && afterCleanUrlNew != null) {
                  var imageDataArrRes = afterCleanUrlNew.split(',');

                  for (var j = 0; j < imageDataArrRes.length; j++) {
                  afterCleanImageArrNew.push({
                      'url': weburl + '/' + imageDataArrRes[j]
                  });
                  }
                  that.afterCleanImageArr =  afterCleanImageArrNew;
              }

              if(detail.appointmentNo) that.qrcode(detail.appointmentNo);

              if(detail.bpmStatus == 3 && detail.xcOperationSignUrl && detail.driverSignUrl)
              {
                that.showPrintBtn = true;
              }
          }

          that.detail = detail;

        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    printPdf()
    {
      
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (isWeixin) {
        this.isWeChat = true;
        this.showPrintBtn = false
      }else{
        this.isWeChat = false;
        this.showPrintBtn = true
      }
    },
    openInBrowser() {
      var printurl = this.GLOBAL.printurl;
      var id = this.$route.params.id;
      const url = printurl+"/caoche/getAppointmentPdf/"+id; // 获取当前页面链接
      // console.log(url)
      window.location.href = url
      // if (navigator.clipboard?.writeText) {
      //   try {
      //     navigator.clipboard.writeText(url)
      //       alert("链接已复制，请粘贴到浏览器中打开");
      //     } catch {
      //       return fallbackCopy(url)
      //     }
      //   } else {
      //     return fallbackCopy(url)
      //   }
      

    },
    
  }
}

// function fallbackCopy(text) {
//   const input = document.createElement('input')
//   input.value = text
//   document.body.appendChild(input)
//   input.select()
//   const success = document.execCommand('copy')
//   document.body.removeChild(input)
//   return success
// }
</script>

<style lang="scss" scoped>
.detail-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 60px;
}

.detail-content {
  padding: 12px;
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;

  .card-header {
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;

    .header-title {
      font-size: 16px;
      font-weight: 600;
      color: #323233;
      position: relative;
      padding-left: 10px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #4080ff;
        border-radius: 2px;
      }
    }
  }

  .info-list {
    padding: 12px 16px;
  }

  .info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f5f6f7;

    &:last-child {
      border-bottom: none;
    }

    .info-label {
      width: 100px;
      font-size: 14px;
      color: #969799;
    }

    .info-value {
      flex: 1;
      font-size: 14px;
      color: #323233;

      &.highlight {
        color: #ff6b00;
        font-weight: 500;
      }

      .detection-desc {
        display: block;
        color: #969799;
        font-size: 12px;
        margin-top: 12px;
        line-height: 2.0;
      }
    }
  }

  .image-container {
    padding: 12px;

    .detail-image {
      width: 100%;
      min-height: 200px;
      max-height: 300px;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}

.qrcode-card {
  margin-bottom: 130px;
  .qrcode-container {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;

    img {
      width: 200px !important;
      height: 200px !important;
    }
  }
}

.footer-actions {
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 10;

  .print-btn {
    height: 44px;
    font-size: 16px;
    background-color: #4080ff;
    border: none;
  }
}

.wechat-tip-card {
  padding: 20px;

  .wechat-tip {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 24px;
    text-align: center;

    p {
      font-size: 16px;
      color: #323233;
      margin-bottom: 20px;
    }

    .browser-btn {
      margin-bottom: 12px;
      background-color: #4080ff;
      border: none;
    }

    .return-btn {
      border: 1px solid #dcdee0;
      color: #323233;
    }
  }
}
</style>

<style lang="css" scoped>
.qrcode-container >>> img {
    width: 50vw;
    height: 50vw;
}
.qrcode-container >>> canvas {
  width: 50vw !important;
  height: 50vw !important;
}
</style>
  